import createPubSub, { PubSub } from "@lazarentertainment/js-pubsub"
import { useCallback, useRef } from "react"

export function usePubSub<T>() {
  const pubSubRef = useRef<PubSub<T>>()
  if (!pubSubRef.current) {
    pubSubRef.current = createPubSub<T>()
  }
  const pubSub = pubSubRef.current

  // A convenience for passing to useEffect, e.g.
  // useEffect(() => subscribe("event", () => { ... }), [subscribe])
  const subscribe = useCallback(
    <E extends keyof T>(
      event: E,
      callback: (arg: T[E]) => void,
      options?: { once: boolean },
    ) => {
      pubSub.subscribe(event, callback, options)
      return () => pubSub.unsubscribe(event, callback)
    },
    [pubSub],
  )

  return {
    ...pubSub,
    subscribe,
  }
}

export type Subscribe<T> = ReturnType<typeof usePubSub<T>>["subscribe"]
export type Publish<T> = ReturnType<typeof usePubSub<T>>["publish"]
